import React, { useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { MUSICADE_EVENT_URL, MUSICADE_PROFILE_URL } from "./constants/apiUrls";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import PaymentReturn from "./pages/PaymentReturn";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import EventCategory from "./pages/event/EventCategory";
import EventDetails from "./pages/event/EventDetails";
import PrivateEventLoader from "./pages/event/PrivateEventLoader";

const EventsRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(MUSICADE_EVENT_URL);
  }, []);
  return null;
};

const ProfileRedirect: React.FC = () => {
  const { username } = useParams<{ username: string }>();
  useEffect(() => {
    if (username) window.location.replace(MUSICADE_PROFILE_URL(username));
  }, [username]);
  return null;
};

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/events" element={<EventsRedirect />} />
    <Route path="/events/private/:token" element={<PrivateEventLoader />} />
    <Route path="/category/:category" element={<EventCategory />} />
    <Route path="/embedded_checkout_page/:eventUuid" element={<EventDetails />} />
    <Route path="/payment-return" element={<PaymentReturn />} />
    <Route path="/profile/:username" element={<ProfileRedirect />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
